import axios from "axios";
import { BACKEND_ROOT, SSR_USER_AGENT } from "../config/constants";
import { refreshToken, updateAxiosToken } from "./auth";

let headers = {};

if (typeof window === "undefined") {
  headers["User-Agent"] = SSR_USER_AGENT;
}

const axiosInstance = axios.create({
  baseURL: `${BACKEND_ROOT}/api/render`,
  headers: headers,
});

let tries = 0;

axiosInstance.interceptors.response.use(null, err => {
  if (err.response.status === 403) {
    return refreshToken()
      .then(authToken => {
        updateAxiosToken(authToken);

        tries++;

        if (tries < 5) {
          // Retry the request with all the same configuration, except do _not_ reuse the Auth header
          delete err.config.headers.Authorization;
          return axiosInstance.request(err.config);
        }

        return Promise.reject(err);
      })
      .catch(() => {
        return Promise.reject(err);
      });
  }

  return Promise.reject(err);
});

export default axiosInstance;
